export const useDefaultData = ({Helpers}) => {

    const {getCurrentDate} = Helpers

    const defaultFormGlobal = {
        idgestion: 0,
        idgestiontipo: 0,
        idcredito: 0,
        cliente: '',
        seguro: '',
        check_seguro: false,
        check_carta: false,
        document_path: '',
        fecha_ren_seguro: '',
        fecha_fin_contrato: '',
        total_seguro: '',
        dpi: '',
        telefono: '',
        vehiculo: '',
        credito_dia_pago: '',
        gestion_nuevo_dia_pago: '',
        total_cuota: '',
        gestion_descripcion: '',
        monto_devolucion: '',
        cargos_extras_total: '',
        deposito_total: '',
        costo_retiro_gps: '300.00',
        aprobacion_check: 'Pendiente Aprobacion',
        aprobacion_fecha: '',
        aprobacion_observaciones: '',

        fecha_finalizacion: '',
        suma_dias_atraso_totales: '',
        suma_total_pagar: '',
        total_gastos_juridicos: '',
        total_deuda_credito: '',
        mora_pendiente: '',
        total_deuda_mora: '',
        gestion_nuevo_idcredito: '',
        total_negociado: '',

        total_gastos_admin:'',
        nuevo_plazo: 0,
        plazo_anios: 0,
        nuevo_cuota_niv: 0,
        nuevo_total_cuota: 0,
        interes_total: 0,
        saldo_financiado: 0,

        clean_saldo_financiado: 0,
        clean_gps: 0,
        clean_seguro: 0,
        clean_otros: 0,
        clean_nuevo_cuota_niv: 0,
        clean_nuevo_total_cuota:0,

        acceptedFiles: [],
        fileRejections: [],

        transactions: [],
        rowSelectedTransaction: [],

        exoneraciones: [],
        rowSelectedExoneracion: [],
        porcentaje_exoneracion: 0,
        total_exoneracion: '0.00'
    }

    const optionsAprobacionCheck = [
        { value: 'Aprobado', label: 'Aprobado' },
        { value: 'Rechazado', label: 'Rechazado' },
        { value: 'Pendiente Aprobacion', label: 'Pendiente Aprobacion' },
        // { value: 'Devuelto a Gestor', label: 'Devuelto a Gestor' },
    ];

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormDeposit = {
        iddeposit: '',
        idcaja: '',
        idbanco: '',
        boleta_numero: '',
        boleta_foto_path: '',
        boleta_foto_originalname: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        deposito_dolares: '',
        deposito_fecha: getCurrentDate(),
        deposito_moneda: '',
        deposito_monto: '',
        deposito_observaciones: '',
        deposito_quetzales: '',
        deposito_tipo_cambio: 7.8,
        movimiento_tipo: '',
        aprobacion_check: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],

        clean_deposito_monto: 0,
        clean_deposito_quetzales: 0,
        clean_deposito_dolares: 0,
    }

    const optionsTypeMoneda = [
        { value: 'QUETZAL', label: 'QUETZAL' },
        { value: 'DOLAR', label: 'DOLAR' },
    ];

    const optionsTypePayment = [
        { value: 'EFECTIVO', label: 'EFECTIVO' },
        // { value: 'DEPOSITO', label: 'DEPOSITO' },
    ];

    const optionsAprobacionDeposit = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'PENDIENTE', label: 'PENDIENTE' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
    ];



    return Object.freeze({
        defaultFormGlobal,
        optionsAprobacionCheck,
        defaultDataModal,
        defaultFormDeposit,
        optionsTypeMoneda,
        optionsTypePayment,
        optionsAprobacionDeposit
    })
}